module.exports = __webpack_public_path__ + "img/0.b33b4767.png";